import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navLinks } from '../data/site';
import Logo from './Logo';
import './Header.css';

const Header: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    // Close the mobile drawer whenever the route changes.
    useEffect(() => setIsOpen(false), [pathname]);

    // Lock body scroll behind the open drawer.
    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setIsOpen(false);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    return (
        // The drawer is a sibling of <header>, not a child: the header's
        // backdrop-filter would otherwise become the containing block for its
        // position:fixed descendants and collapse the drawer to nav height.
        <>
            <header className={`site-header ${isScrolled ? 'is-scrolled' : ''}`}>
                <div className="container site-header__inner">
                    <Link to="/" className="site-header__brand" aria-label="Kifayti home">
                        <Logo />
                    </Link>

                    <nav className="site-header__nav" aria-label="Primary">
                        <ul>
                            {navLinks.map((link, i) => (
                                <li key={link.to} className="enter" style={{ ['--i' as string]: i }}>
                                    <NavLink
                                        to={link.to}
                                        className={({ isActive }) =>
                                            `underline-grow ${isActive ? 'is-active' : ''}`
                                        }
                                    >
                                        {link.label}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div className="site-header__actions">
                        <Link to="/contact" className="btn btn--primary btn--sm">
                            Talk to us
                        </Link>
                        <button
                            className={`site-header__burger ${isOpen ? 'is-open' : ''}`}
                            onClick={() => setIsOpen((v) => !v)}
                            aria-label={isOpen ? 'Close menu' : 'Open menu'}
                            aria-expanded={isOpen}
                        >
                            <span />
                            <span />
                        </button>
                    </div>
                </div>
            </header>

            <div className={`mobile-drawer ${isOpen ? 'is-open' : ''}`}>
                <nav aria-label="Mobile">
                    <ul>
                        <li style={{ ['--i' as string]: 0 }}>
                            <NavLink to="/" end className={({ isActive }) => (isActive ? 'is-active' : '')}>
                                Home
                            </NavLink>
                        </li>
                        {navLinks.map((link, i) => (
                            <li key={link.to} style={{ ['--i' as string]: i + 1 }}>
                                <NavLink
                                    to={link.to}
                                    className={({ isActive }) => (isActive ? 'is-active' : '')}
                                >
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <Link
                    to="/contact"
                    className="btn btn--primary btn--lg mobile-drawer__cta"
                    style={{ ['--i' as string]: navLinks.length + 1 }}
                >
                    Talk to us
                </Link>
            </div>
        </>
    );
};

export default Header;
